<template>
  <div v-if="order">
    <v-row>
      <v-col align="left">
        <v-card
          outlined
          rounded
          class="mx-auto my-12"
          max-width="374"
          color="cardIsland"
        >
          <template v-if="!isValidWithinTime">
            <v-card-title
              v-if="!isValidWithinTime"
              class="text-h6 font-weight-bold"
            >
              <v-icon style="color:#F5AC37">mdi-timer</v-icon>&nbsp;{{capitaliseFirstLetter(this.orderType)}} order status:&nbsp;
              <span class="text-uppercase orange-text">Pending</span>
            </v-card-title>
            <v-card-text v-if="!isValidWithinTime">
              Please wait while we confirm your payment.
            </v-card-text>
            <v-divider></v-divider>
            <v-card-title class="text-h6 font-weight-bold">Details</v-card-title>
            <OrderDetails
              :orderType="orderType"
              :isReceipt="true"
            />
            <v-divider></v-divider>
            <v-card-title class="text-h6 font-weight-bold">We'll do the rest</v-card-title>
            <v-card-text>
              Once we confirm your payment, this order status will change to "PAID" and you will be emailed a receipt.
              In the meantime, if you have any questions, please do not hesitate to <a href="">contact us here</a>.
              <div class="d-flex align-center justify-center pt-5">
                <v-btn
                  block
                  color="primary"
                  @click="$router.push('/dashboard')"
                >Back to dashboard</v-btn>
              </div>
            </v-card-text>
          </template>

          <template v-if="isValidWithinTime">
            <v-card-title class="text-h6 font-weight-bold">1. Order details</v-card-title>
            <v-card-text>
              <OrderDetails
                :orderType="orderType"
                :isReceipt="false"
              />
            </v-card-text>
            <v-divider></v-divider>
            <v-card-title class="text-h6 font-weight-bold">2. Make your payment</v-card-title>
            <v-card-text v-if="orderType === 'sell'">
              <!-- Choose one of the following three options:
              <v-card
                class="pb-4 mt-2"
                color="backgroundLighter"
                outlined
                rounded
              >
                <v-btn-toggle
                  v-model="toggle_exclusive"
                  dense
                  mandatory
                  style="width:100%"
                >
                  <v-btn
                    @click="paymentMethod = 'address'"
                    style="width:33.34%"
                    checked
                    color="backgroundLighter"
                  >
                    <v-icon
                      class="mr-1"
                      small
                      color="white"
                    >mdi-bank</v-icon>
                    Address
                  </v-btn>
                  <v-btn
                    @click="paymentMethod = 'wallet'"
                    style="width:33.34%"
                    color="backgroundLighter"
                  >
                    <v-icon
                      class="mr-1"
                      small
                      color="white"
                    >mdi-wallet</v-icon>
                    Wallet
                  </v-btn>
                  <v-btn
                    @click="paymentMethod = 'qrcode'"
                    style="width:33.34%"
                    color="backgroundLighter"
                  >
                    <v-icon
                      class="mr-1"
                      small
                      color="white"
                    >mdi-receipt</v-icon>
                    QR Code
                  </v-btn>
                </v-btn-toggle>
                <v-card-text v-if="paymentMethod === 'address'">
                  Send exactly:
                  <div class="d-flex flex-row">
                    <v-text-field
                      suffix="BTC"
                      readonly
                      outlined
                      hide-details
                      dense
                      :value="order.coinAmount"
                    ></v-text-field>
                    <v-btn
                      class="ml-1"
                      color="primary"
                    >Copy</v-btn>
                  </div>
                  To address:
                  <div class="d-flex flex-row">
                    <v-text-field
                      readonly
                      outlined
                      hide-details
                      dense
                      value="129YzAAwJ6cHnRRXCBd5rLQFMYSbgdiLiS"
                      class="mx-auto"
                    ></v-text-field>
                    <v-btn
                      class="ml-1"
                      color="primary"
                    >Copy</v-btn>
                  </div>
                </v-card-text>
                <v-card-text v-if="paymentMethod === 'wallet'">
                  <div>
                    Click the button to open your Bitcoin wallet and load this sell order.
                  </div>
                  <v-btn
                    color="primary"
                    block
                    class="mt-2"
                  >Open Bitcoin wallet</v-btn>
                </v-card-text>
                <v-card-text v-if="paymentMethod === 'qrcode'">
                  <div>
                    Scan the QR code to open your Bitcoin wallet and load this sell order.
                  </div>
                  >>>>>Insert QR code
                </v-card-text>
              </v-card> -->
              <v-card
                class="pb-4 mt-2"
                style="border-radius:5px"
                color="backgroundLighter"
                outlined
              >
                <v-card-text>
                  Send exactly:
                  <div class="d-flex flex-row mb-2">
                    <v-text-field
                      suffix="BTC"
                      readonly
                      outlined
                      hide-details
                      dense
                      :value="order.coinAmount"
                    ></v-text-field>
                    <v-btn
                      @click="copyToClipBoard(order.coinAmount)"
                      class="ml-1"
                      height="40"
                      color="primary"
                    >Copy</v-btn>
                  </div>
                  To address:
                  <div class="d-flex flex-row">
                    <v-text-field
                      readonly
                      outlined
                      hide-details
                      dense
                      :value="myBtcWalletAddress"
                      class="mx-auto"
                    ></v-text-field>
                    <v-btn
                      @click="copyToClipBoard(myBtcWalletAddress)"
                      class="ml-1"
                      height="40"
                      color="primary"
                    >Copy</v-btn>
                  </div>
                </v-card-text>
              </v-card>
            </v-card-text>
            <v-card-text v-if="orderType === 'buy'">
              <!-- We use POLi Payments, a business of Australia Post as our online payment option.
            Click the button below to make a secure payment with POLi.
            <v-btn
              color="primary"
              block
              class="my-2"
            >Pay with POLi</v-btn> -->
              <v-card
                class="pb-4 mt-2"
                style="border-radius:5px"
                color="backgroundLighter"
                outlined
              >
                <v-card-text>
                  Please make your payment of {{formatCurrency(order.audAmount)}} to <span class="font-weight-bold text-body-1">PayID: 0410967625</span>
                </v-card-text>
              </v-card>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-title class="text-h6 font-weight-bold">3. All done!</v-card-title>
            <v-card-text>
              <div v-if="orderType === 'buy'">
                We'll take care of the rest from here. We'll confirm your payment and match it against your order.
                <br /><br />
                Once processed, this order status will update from "UNPAID" to “PAID” and a receipt will be emailed to you. If you have any questions, please do not hesitate to
                <a href="">contact us here</a>.
              </div>
              <div v-if="orderType === 'sell'">
                We'll take care of the rest from here. Please allow some time for payments to clear. Payments made before 5PM often clear the same day otherwise, they will clear the very next business day.
                <br /><br />
                Once processed, this order status will update from "UNPAID" to “PAID” and a receipt will be emailed to you. If you have any questions, please do not hesitate to
                <a href="">contact us here</a>.
              </div>
               <div class="d-flex align-center justify-center pt-5">
                <v-btn
                  block
                  color="primary"
                  @click="$router.push('/dashboard')"
                >Back to dashboard</v-btn>
              </div>
            </v-card-text>
          </template>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import OrderDetails from "../OrderDetails.vue"
import { mapState } from 'vuex'
import { utilsMixin } from '../../mixins/utilsMixin'

export default {
  props: ["orderType", "orderStatus", "isValidWithinTime"],
  mixins: [utilsMixin],
  components: {
    OrderDetails,
  },
  data() {
    return {
      myBtcWalletAddress: '129YzAAwJ6cHnRRXCBd5rLQFMYSbgdiLiS',
      toggle_exclusive: 3,
      paymentMethod: 'address',
    }
  },
  computed: {
    ...mapState('order', ['order']),
  },
  mounted() {
    console.log('isValidWithinTime is', this.isValidWithinTime)
  }
}
</script>
